import { shallow } from 'zustand/shallow';
import { useGamesStore } from '../../store';

export const useGetPagination = () => {
  return useGamesStore((store) => store.pagination || {}, shallow);
};
